import React from "react"
import { MentionList } from "../mention-list"
import { Modal, SectionListData } from "~/ui/primitives"
import styled from '~/ui/styled'
import Icon from "~widgets/icon"
import { User } from "../../models"
import { Mask } from "~widgets/mask"

interface Props {
  title?: string
  visible: boolean
  setVisible: (val: boolean) => void
  onSelect?: (item: User) => void
  userSections?: SectionListData<User, { letter: string; data: User[] }>[]
}

const ModalView = styled.View`
  width: 100%;
  position: absolute;
  bottom: 0px;
`
const Container = styled.SafeAreaView`
  flex: 1;
  justify-content: center;
  background-color: #fff;
`
const Header = styled.View`
  flex-direction: row;
  height: 54px;
  align-items: center;
  position: relative;
`
const IconWrap = styled.Pressable`
  position: absolute;
  left: 10px;
`
const Title = styled.Text`
  font-weight: 600;
  font-size: 16px;
  margin: auto;
`
const MentionModal: React.FC<Props> = ({ title, visible, onSelect, setVisible, userSections }) => {
  return (
    <Modal animationType="fade" transparent visible={visible}>
      <Mask onClick={() => setVisible(false)}></Mask>
      <ModalView>
        <Container>
          <Header>
            <IconWrap onClick={() => setVisible(false)}>
              <Icon name="down" color="#999" size={25} />
            </IconWrap>
            <Title>{title}</Title>
          </Header>
          <MentionList onSelect={onSelect} userSections={userSections} />
        </Container>
      </ModalView>
    </Modal>
  )
}

export default MentionModal
